module.exports = __webpack_public_path__ + "img/marker.58898f93.svg";